import { initBottomCvArea, initSharedPageInteractions, syncChangedActionForm } from './shared_page_interactions'
import { initScrollSnapSlider, scrollSnapSlider, updateScrollSnapSliderControls } from './scroll_snap_slider'
import { applyCompanyDetailAreaContext } from './company_area_context'
import './tail-clamp-init'
import './review-card-details'

export { initBottomCvArea, syncChangedActionForm }

const DETAIL_SLIDER_ROOT_SELECTOR = '[data-company-detail-slider]'
const DETAIL_SLIDER_TRACK_SELECTOR = '[data-company-detail-slider-track]'
const DETAIL_SLIDER_PREV_SELECTOR = '[data-company-detail-slider-prev]'
const DETAIL_SLIDER_NEXT_SELECTOR = '[data-company-detail-slider-next]'
const COMPANY_DETAIL_SLIDER_OPTIONS = {
  rootSelector: DETAIL_SLIDER_ROOT_SELECTOR,
  trackSelector: DETAIL_SLIDER_TRACK_SELECTOR,
  prevSelector: DETAIL_SLIDER_PREV_SELECTOR,
  nextSelector: DETAIL_SLIDER_NEXT_SELECTOR,
  snapToItemRootSelector: '[data-company-detail-slider-snap-to-item]',
  initializedDataKey: 'companyDetailSliderInitialized',
}

export function updateCompanyDetailSliderControls(root) {
  updateScrollSnapSliderControls(root, COMPANY_DETAIL_SLIDER_OPTIONS)
}

export function scrollCompanyDetailSlider(root, direction) {
  scrollSnapSlider(root, direction, COMPANY_DETAIL_SLIDER_OPTIONS)
}

export function initCompanyDetailSliders(root = document) {
  initScrollSnapSlider(root, COMPANY_DETAIL_SLIDER_OPTIONS)
}

function highlightAndScroll(elements, highlightAttribute, scrollOptions, openDetails = false) {
  if (elements.length === 0) return

  elements.forEach((element) => {
    if (openDetails) element.closest('details')?.setAttribute('open', '')
    element.setAttribute(highlightAttribute, '')
  })

  const firstElement = elements[0]
  firstElement.focus({ preventScroll: true })
  firstElement.scrollIntoView(scrollOptions)
}

export function initCompanyOfficeHashNavigation() {
  if (window.location.hash === '#company-head-office') {
    highlightAndScroll([...document.querySelectorAll('#company-head-office')], 'data-office-highlighted', { block: 'start', behavior: 'instant' })
    return
  }

  const match = window.location.hash.match(/^#company-offices-([1-9][0-9]*(?:-[1-9][0-9]*)*)$/)
  if (!match) return

  const officeIds = new Set(match[1].split('-'))

  const rows = [...document.querySelectorAll('[data-company-office-id]')]
    .filter((row) => officeIds.has(row.dataset.companyOfficeId))
  highlightAndScroll(rows, 'data-office-highlighted', { block: 'start', behavior: 'instant' }, true)
}

export function initCompanyAreaHashNavigation() {
  const match = window.location.hash.match(/^#company-(case|review)-area-([1-9][0-9]*)$/)
  if (!match) return

  const [, type, areaId] = match
  const root = type === 'case' ? '#company-reform-cases' : '#company-review-list'
  const areaAttribute = `data-company-${type}-area-ids`
  const cards = [...document.querySelectorAll(`${root} [${areaAttribute}]`)]
    .filter((card) => card.getAttribute(areaAttribute).split(/\s+/).includes(areaId))
  highlightAndScroll(cards, `data-${type}-highlighted`, { block: 'start', inline: 'start', behavior: 'instant' })
}

export function initCompanySingle() {
  initSharedPageInteractions()
  initCompanyDetailSliders()
  applyCompanyDetailAreaContext()
  initCompanyOfficeHashNavigation()
  initCompanyAreaHashNavigation()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCompanySingle)
} else {
  initCompanySingle()
}
